import ContentLoader from 'react-content-loader';

export const Skeleton = ContentLoader;
